import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  CircularProgress,
} from "@mui/material";

const BondArchivesDeleteDialog = ({
  deleteDialogOpen,
  isDeleting,
  handleDeleteClose,
  handleReviewBond,
  handleDeleteConfirm,
}) => {
  return (
    <Dialog
      open={deleteDialogOpen}
      onClose={() => !isDeleting && handleDeleteClose()}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Delete Bond</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete this bond? This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleReviewBond} color="primary">
          Review Bond
        </Button>
        <Button onClick={handleDeleteClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={handleDeleteConfirm}
          color="error"
          variant="contained"
          disabled={isDeleting}
          startIcon={isDeleting && <CircularProgress size={20} />}
        >
          {isDeleting ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

BondArchivesDeleteDialog.propTypes = {
  deleteDialogOpen: PropTypes.bool.isRequired,
  isDeleting: PropTypes.bool.isRequired,
  handleDeleteClose: PropTypes.func.isRequired,
  handleReviewBond: PropTypes.func.isRequired,
  handleDeleteConfirm: PropTypes.func.isRequired,
};

export default BondArchivesDeleteDialog;
